import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { getWeddingPageByType, getWeddingPageByTypeV2 } from '../../../actions/PublicWebsiteActions';
import { resetEntities } from '../../../actions/website/EntityActions';
import Address from '../../common/ui/Address';

class Events extends Component {
  componentDidMount() {
    const production = window.zola.env === 'production';
    const { getEventEntities, forPreview, getEventEntitiesV2 } = this.props;
    if (!forPreview && production) {
      getEventEntities();
    } else if (!forPreview && !production) {
      getEventEntitiesV2();
    }
  }

  componentWillUnmount() {
    const { unloadEntities, forPreview } = this.props;
    if (!forPreview) {
      unloadEntities();
    }
  }

  render() {
    const { events, orderedIds, page, forPreview, busy, wedding } = this.props;
    const noCmsHeader = !page.description && !page.header_image_url;
    return (
      <div id="events-page" className="container">
        {page && !busy && (
          <div className={['cms-page-header', ((!page.description && !page.header_image_url) || !page.title ? 'flex-container' : null)].join(' ')}>
            <div className="cms-header-accent-top-left" />
            <div className="cms-header-accent-top-right" />
            <div className="cms-header-accent-bottom-left" />
            <div className="cms-header-accent-bottom-right" />
            <h1 className="for-small-laptops">{page.title}</h1>
            {window.zola.env !== 'production' ? (
              <span>
                {page.header_image_url && (
                  <img src={`${page.header_image_url}?h=400`} alt={`The Wedding Website of ${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}`} className="img-responsive center-block" />
                )}
              </span>
            ) : (
              <span>
                {page.header_image_url && (
                  <img src={`${page.header_image_url}?h=400`} alt={page.title} className="img-responsive center-block" />
                )}
              </span>
            )}
            {page.description && (
              <p className={['page-description', (page.header_image_url ? 'has-image-above' : null)].join(' ')}>{page.description}</p>
            )}
          </div>
        )}
        <div className={['entity-sections event-sections', noCmsHeader ? 'no-cms-above' : ''].join(' ')}>
          <div className="entity-sections-accent-top-left" />
          <div className="entity-sections-accent-top-right" />
          <div className="entity-sections-accent-bottom-left" />
          <div className="entity-sections-accent-bottom-right" />
          {forPreview && events && orderedIds.map(eventId => (
            <div key={eventId} className="events-container">
              {events[eventId].public && (
                <div className="entity-section event-section" key={eventId}>
                  <div className="entity-section-title event-section-title">
                    <h2 className="event-name">
                      {events[eventId].name}
                    </h2>
                    <h4 className="event-date">
                      {moment.utc(events[eventId].start_at).format('dddd, MMMM D, YYYY')}
                    </h4>
                    <h4 className="event-time">
                      {moment.utc(events[eventId].start_at).format('h:mm a')}{events[eventId].end_at && ` - ${moment.utc(events[eventId].end_at).format('h:mm a')}`}
                    </h4>
                  </div>
                  <div className="entity-section-description event-section-description">
                    <i className={`zolaicon-public zolaicon-public-${events[eventId].type.toLowerCase()}`} />
                    <Address
                      name={events[eventId].venue_name}
                      address1={events[eventId].address_1}
                      address2={events[eventId].address_2}
                      city={events[eventId].city}
                      state={events[eventId].state_province}
                      zip={events[eventId].postal_code}
                      countryCode={events[eventId].country_code}
                    />
                    {events[eventId].contact_phone && (
                      <p>{events[eventId].contact_phone}</p>
                    )}
                    {events[eventId].attire && (
                      <p className="event-note">
                        {events[eventId].attire}
                      </p>
                    )}
                    {events[eventId].note && (
                      <p className="event-note">
                        {events[eventId].note}
                      </p>
                    )}
                    <div className="event-actions">
                      {events[eventId].google_map_url && (
                        <button className="btn btn-primary map-button">Map</button>
                      )}
                      <button className="btn btn-primary cal-button">Add to Calendar</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
          {!forPreview && events && events.map((event, idx) => (
            <div key={idx} className="events-container">
              {event.public && (
                <div className="entity-section event-section">
                  <div className="entity-section-title event-section-title">
                    <h2 className="event-name">
                      {event.name}
                    </h2>
                    <h4 className="event-date">
                      {moment.utc(event.start_at).format('dddd, MMMM D, YYYY')}
                    </h4>
                    <h4 className="event-time">
                      {moment.utc(event.start_at).format('h:mm a')}{event.end_at && ` - ${moment.utc(event.end_at).format('h:mm a')}`}
                    </h4>
                  </div>
                  <div className="entity-section-description event-section-description">
                    <i className={`zolaicon-public zolaicon-public-${event.type ? event.type.toLowerCase() : 'other'}`} />
                    <Address
                      name={event.venue_name}
                      address1={event.address_1}
                      address2={event.address_2}
                      city={event.city}
                      state={event.state_province}
                      zip={event.postal_code}
                      countryCode={event.country_code}
                    />
                    {event.contact_phone && (
                      <p>{event.contact_phone}</p>
                    )}
                    {event.attire && (
                      <p className="event-note">
                        {event.attire}
                      </p>
                    )}
                    {event.note && (
                      <p className="event-note">
                        {event.note}
                      </p>
                    )}
                    <div className="event-actions">
                      {event.google_map_url && (
                        <a href={event.google_map_url} className="btn btn-primary map-button" target="_blank" rel="noopener noreferrer">Map</a>
                      )}
                      {event.start_at && (
                        <form action="/web-api/v1/publicwedding/calendar-event" method="post">
                          <input type="hidden" name="start" value={moment.utc(event.start_at).format('YYYY-MM-DD HH:mm')} />
                          <input type="hidden" name="end" value={event.end_at ? moment.utc(event.end_at).format('YYYY-MM-DD HH:mm') : ''} />
                          <input type="hidden" name="title" value={event.name} />
                          <input type="hidden" name="description" value={event.note || ''} />
                          <input type="hidden" name="location" value={`${event.venue_name} ${event.address_1 || ''} ${event.address_2 || ''} ${event.city || ''} ${event.state_province || ''} ${event.postal_code || ''}`} />
                          <input type="submit" className="btn btn-primary cal-button" value="Add to Calendar" />
                        </form>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
          {((forPreview && orderedIds && orderedIds.length === 0) || (!forPreview && events && events.length === 0)) && (
            <p className="text-center empty-entity-text">We&#39;re still planning the weekend&#39;s events and will update this page soon.</p>
          )}
        </div>
      </div>
    );
  }
}

Events.propTypes = {
  events: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getEventEntities: PropTypes.func.isRequired,
  getEventEntitiesV2: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  forPreview: PropTypes.bool,
  page: PropTypes.shape({}).isRequired,
  busy: PropTypes.bool,
  wedding: PropTypes.shape({})
};

const mapStateToProps = (state, ownProps) => ({
  events: ownProps.forPreview ? state.website.entities.byId : state.publicWebsite.entities,
  orderedIds: ownProps.forPreview ? state.website.entities.orderedIds : null,
  page: ownProps.forPreview ? ownProps.page : state.publicWebsite.page,
  busy: state.publicWebsite.busy,
  wedding: state.publicWebsite.wedding
});

const mapDispatchToProps = dispatch => ({
  getEventEntities: () => dispatch(getWeddingPageByType('event')),
  getEventEntitiesV2: () => dispatch(getWeddingPageByTypeV2('event')),
  unloadEntities: () => dispatch(resetEntities())
});

const EventContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Events);

export default EventContainer;



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/Events.jsx
 **/